<template>
  <Breadcrumbs
      title="Edit User"
      :breadcrumbs="[
      { label: 'Master Data', path: '' },
      { label: 'Users', path: '/users' },
      { label: 'Edit User', path: '/edit-user' },
    ]"
  />
  
  <div class="container-fluid">
    <div class="row project-cards">
      <editUserForm/>
    </div>
  </div>
</template>
  
  
<script>
import editUserForm from './editUserForm.vue';

export default {
  components: {
      editUserForm
  }
}
</script>